<template>
  <div v-if="isDataLoading" class="d-flex justify-content-center align-items-center h-100">
    <Preloader />
  </div>

  <EditProfile v-else :userId="userId" @close="onClose" :isUserProfile="isUserProfile" :userData="tableData"
    @profileUpdate="onProfileUpdate" @avatarUpdate="onAvatarUpdate" @getName="getName" :breadcrumbs="[{
      text: 'Home',
      to: { name: 'home' }
    }, { text: name, click: () => onClose() }]" />
</template>

<script>
import { mapActions } from 'vuex'
import EditProfile from '@components/EditProfile'
import { validationMixin } from 'vuelidate'
import { permissions } from '@mocks/permissions'
import Preloader from '@components/Preloader'

export default {
  name: 'Profile',
  mixins: [validationMixin],
  components: {
    EditProfile,
    Preloader
  },
  computed: {
    tableData () {
      const data = this.table.items
      const contactData = data.contacts
      return { ...contactData, ...data }
    },
    name () {
      return this.userName
    }
  },
  data () {
    return {
      permissions,
      isDataLoading: false,
      userId: null,
      userType: null,
      userName: '',
      userAvatar: '',
      userPosition: '',
      isUserProfile: false,
      mainProps: { width: 75, height: 75, class: 'm1', src: '/images/avatar-placeholder.png' },
      readonly: true,
      table: {
        items: {}
      },
      modalRestoreUser: {
        show: false,
        user: null
      },
      modalDeletedUser: {
        show: false,
        user: null
      },
      changePassword: {
        showModal: false,
        form: {
          'password': {
            type: 'input',
            name: 'password',
            label: 'Password',
            placeholder: 'password',
            typeInput: 'password',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          }
        }
      },
      isAvatarUploading: false,
      editParam: false,
      test: ''
    }
  },
  methods: {
    ...mapActions({
      setComment: 'comments/setComment'
    }),
    setTable (res) {
      const data = { ...res }
      data.userStatus = data.deleted_at === null && data.exit_at === null && data.status === 'approved'
      data.no_reporting = !!data.no_reporting
      data.employment_type_full_label = data?.employment_type?.label
        ? data.employment_type.label + (data.partner && data.employment_type.type === 'partner' ? ` (${data.partner.company_name})` : '')
        : data.employment_type.name
      data.availability = data.availability && data.availability.name ? data.availability.name : ''
      data.seniority_lvl = data.seniority_lvl && data.seniority_lvl.name ? data.seniority_lvl.name : ''
      data.english_lvl = data.english_lvl && data.english_lvl.name ? data.english_lvl.name : ''
    },

    onProfileUpdate (data) {
      this.userName = data.name
      this.userAvatar = data.avatar_url
      this.userPosition = data.position

      this.table.items = data

      this.setTable(data)
      this.$router.push({ name: 'profile', params: { id: this.userId, type: this.userType } })
    },

    onAvatarUpdate (avatar) {
      this.userAvatar = avatar
    },
    onClose () {
      this.$router.push({ name: 'profile', params: { id: this.userId, type: this.userType } })
    },
    getName (name) {
      this.userName = name
    }
  },
  created () {
    this.userId = this.$route.params.id
    this.userType = this.$route.params.type
    this.isUserProfile = this.userType === 'user-profile'
  },
  async mounted () {
    this.isDataLoading = true
    try {
      const response = this.isUserProfile ? await this.fetchUserProfile(this.userId) : await this.fetchUser(this.userId)
      const data = response.data
      data.show_on_widget = data.show_on_widget === 1 || data.show_on_widget === true
      data.is_contact_person = data.is_contact_person === 1 || data.is_contact_person === true
      this.readonly = false

      this.userName = data.name
      this.userAvatar = data.avatar_url
      this.userPosition = data.position

      this.table.items = data

      this.setTable(data)
    } catch (err) {
      if (err?.response?.status === 404) {
        this.$router.push('/404')
      }
    } finally {
      this.isDataLoading = false
    }
  }
}
</script>

<style scoped lang="scss">

.visibility-form {
  margin-top: 10px;
  margin-bottom: unset;
  .visibility-label {
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
  }
  .visibility-description {
    font-weight: 400;
    font-size: 11px;
    line-height: 20px;
  }
}

.parent-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, auto);
    gap: 30px;
}

.profile-avatar {
    grid-row: span 2 / span 3;
}

.profile-information {
    grid-row: span 2 / span 4;
}

.profile-skills {
    grid-column-start: 1;
    grid-row-start: 3;
}
.profile-skills-without-comments {
  grid-row: 3 / span 2;
}

.profile-personal {
    grid-row: span 2 / span 2;
    grid-column-start: 3;
    grid-row-start: 1;
}

.profile-visibility {
    grid-row: span 2 / span 2;
    grid-column-start: 2;
    grid-row-start: 3;
    grid-column-end: 4;
}

.profile-comment {
  grid-column-start: 1;
  grid-row-start: 4;
  .editor-container {
    height: 100%;
  }
}

.user-profile-badge {
  font-size: 14px;
  vertical-align: middle;
  margin-left: 10px;
}

  .content-wrapper {
    background-color: #ffffff;
    border-radius: 10px;
  }

  .profile-avatar-wrapper {
    padding: 30px;
  }

  .information-wrapper {
    padding: 20px;
  }

  .user-avatar {
    width: 200px;
    height: 200px;
  }

  .info-item {
    margin-top: 10px;
  }

</style>
